import { useState, useEffect } from "react";
import { Download, X } from "lucide-react";
import "./InstallPwaBanner.scss";

export default function InstallPwaBanner() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);

            const dismissed = localStorage.getItem("pwa-install-dismissed");
            if (!dismissed) {
                setShowBanner(true);
            }
        };

        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    const handleInstall = async () => {
        if (!deferredPrompt) return;

        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === "accepted") {
            setShowBanner(false);
        }

        setDeferredPrompt(null);
    };

    const handleDismiss = () => {
        setShowBanner(false);
        localStorage.setItem("pwa-install-dismissed", "true");
    };

    if (!showBanner) return null;

    return (
        <div className="install-pwa-banner">
            <div className="install-pwa-banner__content">
                <Download size={20} />
                <span>Baixe o app no seu celular</span>
            </div>
            <div className="install-pwa-banner__actions">
                <button onClick={handleInstall} className="install-pwa-banner__install">
                    Instalar
                </button>
                <button onClick={handleDismiss} className="install-pwa-banner__dismiss">
                    <X size={18} />
                </button>
            </div>
        </div>
    );
}